import { render, staticRenderFns } from "./EventColorPicker.vue?vue&type=template&id=e5a8b6bc&"
import script from "./EventColorPicker.vue?vue&type=script&lang=js&"
export * from "./EventColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./EventColorPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports